/*
 * Removes any service worker a browser still holds from before registration was
 * disabled.
 *
 * Registration was turned off in Cell-Ed/celled-2#971 because the worker
 * conflicted with Capacitor (ionic-team/capacitor#3485), so src/index.js has
 * called unregister() ever since. The CRA register() path and the workbox
 * service worker it compiled were dead from that point; both went with the move
 * to Vite in LMSNEXT-1291. This call stays, because a browser that installed
 * the worker back then still has it until something tells it otherwise.
 */
export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				console.error(error.message);
			});
	}
}
